/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import { type ForwardedRef, forwardRef } from 'react';
import { type IconProps, Icon } from '../../components/icon/icon.component';

const CalendarStrokeIcon = forwardRef((props: IconProps, ref: ForwardedRef<SVGSVGElement>) => {
  return (
    <Icon {...props} ref={ref}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M3.00002 11.4H21M16.2 1.79999V7.79999M7.80003 1.79999L7.80002 7.79999M4.80002 21.6H19.2C20.5255 21.6 21.6 20.5255 21.6 19.2V7.19999C21.6 5.8745 20.5255 4.79999 19.2 4.79999H4.80002C3.47454 4.79999 2.40002 5.8745 2.40002 7.19999V19.2C2.40002 20.5255 3.47454 21.6 4.80002 21.6Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  );
});

export { CalendarStrokeIcon };
